<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent" :style="{'background-color': d.subscriptionBgColor,
        color: d.subscriptionTextColor}" v-if="d">
        <div class="close" v-on:click="close(false)"></div>
        <h4 class="modalTitle">{{d.subscriptionLabel[lang]}}</h4>
        <p class="modalSubtitle" v-if="d.subscriptionInfo[lang]">{{d.subscriptionInfo[lang]}}</p>
        <div class="formCnt">
          <form v-on:submit.prevent="handleSubmit">
            <div class="fieldGroup" v-for="(item, i) in d.subFormField" :key="`f${i}`"
              :class="{hasError: item.error && item.error[lang]}">
              <label v-if="item.label && item.label[lang]">{{item.label[lang]}}
                <template v-if="item.isRequired">*</template></label>
              <div class="fieldCnt" v-if="['text', 'email', 'date'].includes(item.type)">
                <input :type="item.type" class="field" :placeholder="item.placeholder[lang]"
                  v-model="item.model[lang]" v-on:input="item.error[lang] = null">
              </div>
              <div class="fieldCnt" v-else-if="item.type === 'textarea'">
                <textarea class="field" :placeholder="item.placeholder[lang]" rows="3"
                  v-model="item.model[lang]" v-on:input="item.error[lang] = null"></textarea>
              </div>
              <div class="fieldCnt" v-else-if="item.type === 'checkbox'">
                <div class="ckCnt" v-for="(opt, i2) in item.options" :key="`ck${i2}`">
                  <label>
                    <input type="checkbox" v-model="opt.selected"
                      v-on:change="item.error[lang] = null">
                    <span class="checkmark"></span>
                    {{opt.label}}
                  </label>
                </div>
              </div>
              <div class="fieldCnt" v-else-if="['select', 'dropdown'].includes(item.type)">
                <select class="field" v-model="item.model[lang]"
                  v-on:change="item.error[lang] = null">
                  <option value="__placeholder__" v-if="item.placeholder[lang]">
                    {{item.placeholder[lang]}}
                  </option>
                  <option v-for="(opt, i2) in item.options" :key="`ck${i2}`">
                    {{opt.label}}
                  </option>
                </select>
              </div>
              <div class="fieldError" v-if="item.error && item.error[lang]">
                {{item.error[lang]}}
              </div>
            </div>
            <button class="btn primary" type="submit">
              {{d.subscriptionButton[lang]}}
            </button>
          </form>
        </div>
      </div>
      <ThankYou ref="thankYou"/>
    </div>
  </transition>
</template>

<script>
import ThankYou from '@/components/ThankYou.vue';

export default {
  name: 'shareDialog',
  components: { ThankYou },
  data() {
    return {
      show: false,
      next: null,
      d: null,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    open(d, next) {
      this.d = d;
      this.show = true;
      this.next = next;
    },
    close(b, o) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, o);
    },
    resetForm() {
      // eslint-disable-next-line
      for (const item of this.d.subFormField) {
        if (['select', 'dropdown'].includes(item.type)) {
          item.model[this.lang] = '__placeholder__';
        } else if (item.type === 'checkbox') {
          // eslint-disable-next-line
          for (const opt of item.options) {
            opt.selected = false;
          }
        } else {
          item.model[this.lang] = '';
        }
      }
    },
    handleSubmit() {
      const formData = {
        title: this.d.subscriptionLabel,
        descriptions: this.d.subscriptionInfo,
        emailVerification: this.d.subscriptionEmailVerification,
        lang: this.lang,
        items: [],
      };
      // eslint-disable-next-line
      for (const item of this.d.subFormField) {
        if (item.isRequired) {
          if (['select', 'dropdown'].includes(item.type)) {
            if (!item.model[this.lang] || item.model[this.lang] === '__placeholder__') {
              item.error.id = 'Pilihan harus dipilih';
              item.error.en = 'Field is required';
              return;
            }
          } else if (item.type === 'checkbox') {
            let hasSelected = false;
            // eslint-disable-next-line
            for (const opt of item.options) {
              if (opt.selected) hasSelected = true;
            }
            if (!hasSelected) {
              item.error.id = 'Pilihan harus dipilih';
              item.error.en = 'Field is required';
              return;
            }
          } else if (!item.model[this.lang] || item.model[this.lang].trim() === '') {
            item.error.id = 'Masukan harus diisi';
            item.error.en = 'Field is required';
            return;
          }
        }

        formData.items.push({
          type: item.type,
          isRequired: item.isRequired,
          label: item.label[this.lang],
          model: item.model[this.lang],
          placeholder: item.placeholder[this.lang],
          options: item.options,
        });
      }
      this.$refs.thankYou.open({
        loading: true,
        title: this.d.subscriptionThankYouTitle[this.lang],
        desc: this.d.subscriptionThankYouDesc[this.lang],
      }, () => {
        this.close();
      });
      this.$http.post(this.$config.uri('user/form/submit'), formData).then((r) => {
        this.$refs.thankYou.stopLoading();
        this.resetForm();
      });
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px 20px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      box-sizing: border-box;
      width: 400px;
      max-width: 100%;
      color: #444;
      @media (max-height: 680px) {
        padding: 30px 20px 100px;
        margin: 0; top: auto; bottom: 0;
        border-radius: 5px 5px 0 0;
      }
      .close{
        position: absolute;
        right: 6px; top: 6px;
        width: 40px; height: 40px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .4;
        cursor: pointer;
        transition: all .2s ease;
        &:hover{
          background-color: #e9e9e9;
          opacity: .8;
        }
      }
      .modalTitle{
        font-size: 22px;
        text-align: center;
        margin: 0;
      }
      .modalSubtitle{
        text-align: center;
        font-size: 16px;
        margin: 0;
      }
      .formCnt{
        padding: 16px 0 10px;
        .fieldGroup{
          label{
            color: inherit;
            opacity: .76;
          }
        }
        .btn.primary{
          width: 100%;
        }
      }
    }
  }
</style>
